export default __webpack_public_path__ + "static/media/spinner.64d63a9a.gif";